import {
	getCoFFields,
	getCoFFieldsRejected,
	getCoFFieldsResolved,
	getCustomTableFields,
	getCustomTableFieldsRejected,
	getCustomTableFieldsResolved,
	getProximityAttributeFields,
	getProximityAttributeFieldsRejected,
	getProximityAttributeFieldsResolved,
	saveCoF,
	saveCoFRejected,
	saveCoFResolved,
} from '@Actions';
import { error, success } from '@innovyze/stylovyze';
import { put, retry, select, takeLatest } from '@redux-saga/core/effects';
import { CoFStoreSelector, RiskConfigSelector } from '@Selectors';
import {
	getCoFFieldsApi,
	getCustomTableFieldsApi,
	getProximityAttributeFieldsApi,
} from '@Services/CoF/CoF.services';
import { Category, CoFStoreState, RiskConfig } from '@Types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { mapSnowCfgToMongoCfg } from './Risk.sagas';
import { saveRiskConfigApi } from '@Services/Risk/Risk.services';
import { t } from 'i18next';
import { AnyAction } from 'redux';

export function* getCoFFieldsSaga(action: AnyAction) {
	try {
		const response: AxiosResponse<Category[]> = yield retry(
			5,
			1500,
			getCoFFieldsApi,
			action.payload,
		);
		yield put(getCoFFieldsResolved(response.data));
	} catch (e) {
		yield put(getCoFFieldsRejected());
	}
}
function* watchGetCoFConfig() {
	yield takeLatest(getCoFFields, getCoFFieldsSaga);
}

export function* getProximityAttributeFieldsSaga(action: AnyAction) {
	try {
		const response: AxiosResponse<Category[]> = yield retry(
			5,
			1500,
			getProximityAttributeFieldsApi,
			action.payload,
		);
		yield put(getProximityAttributeFieldsResolved(response.data));
	} catch (e) {
		yield put(getProximityAttributeFieldsRejected());
	}
}
function* watchGetProximityAttributeConfig() {
	yield takeLatest(
		getProximityAttributeFields,
		getProximityAttributeFieldsSaga,
	);
}

export function* getCustomTableFieldsSaga(action: AnyAction) {
	try {
		const response: AxiosResponse<Category[]> = yield retry(
			5,
			1500,
			getCustomTableFieldsApi,
			action.payload,
		);
		yield put(getCustomTableFieldsResolved(response.data));
	} catch (e) {
		yield put(getCustomTableFieldsRejected());
	}
}
function* watchGetCustomTableConfig() {
	yield takeLatest(getCustomTableFields, getCustomTableFieldsSaga);
}

export function* saveCoFConfigSaga(action: AnyAction) {
	try {
		const riskConfig: RiskConfig = yield select(RiskConfigSelector);
		const cofConfig: CoFStoreState = yield select(CoFStoreSelector);

		const finalRiskConfig: RiskConfig = {
			...riskConfig,
			COFCategories: cofConfig.categories,
		};

		const mongoRiskConfig = mapSnowCfgToMongoCfg(finalRiskConfig);

		yield retry(5, 1500, saveRiskConfigApi, mongoRiskConfig);

		yield put(saveCoFResolved());
		yield put(success(t('CoF configuration saved')));
		action.payload.refresh();
	} catch (e) {
		yield put(saveCoFRejected());
		let info = t('No additional information');
		if (axios.isAxiosError(e)) {
			const axiosError = e as AxiosError;
			info = axiosError.response?.statusText ?? info;
		}
		yield put(
			error(
				t('CoF configuration failed to save: {{info}}', {
					info: info,
				}),
			),
		);
	}
}
function* watchSaveCoF() {
	yield takeLatest(saveCoF, saveCoFConfigSaga);
}

const sagaArray = [
	watchGetCoFConfig(),
	watchSaveCoF(),
	watchGetProximityAttributeConfig(),
	watchGetCustomTableConfig(),
];

export default sagaArray;
